import React from 'react';
import { Box, Button, Chip, Stack, Tooltip, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { BLOCKING_STATUSES, getStatusColor, getStatusLabel } from '../types/production-review';

function CountChip({ label, count, color }) {
  if (!count) return null;
  return (
    <Chip
      size="small"
      color={color || 'default'}
      label={`${label}: ${String(count)}`}
      variant={color ? 'soft' : 'outlined'}
    />
  );
}

export default function BatchActions({ review, counts, summary }) {
  const total = Number(counts?.total || 0) || 0;
  const allApproved = Boolean(summary?.allApproved);
  const hasBlocking = Boolean(summary?.hasBlocking);

  const rejectedFailed = (Number(counts?.REJECTED || 0) + Number(counts?.FAILED || 0)) || 0;

  return (
    <Box
      sx={{
        display: 'flex', flexWrap: 'wrap', gap: 1.5,
        alignItems: 'center', justifyContent: 'space-between',
        p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2,
        bgcolor: 'background.paper'
      }}
    >
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
        <Typography variant="subtitle2" sx={{ mr: 1 }}>Resumo ({String(total)} cenas):</Typography>
        <CountChip label="Aprovadas" count={Number(counts?.APPROVED || 0) + Number(counts?.MANUAL_IMAGE || 0)} color="success" />
        <CountChip label={getStatusLabel('WAITING_APPROVAL')} count={Number(counts?.WAITING_APPROVAL || 0)} color={getStatusColor('WAITING_APPROVAL')} />
        <CountChip label={getStatusLabel('REJECTED')} count={Number(counts?.REJECTED || 0)} color={getStatusColor('REJECTED')} />
        <CountChip label={getStatusLabel('FAILED')} count={Number(counts?.FAILED || 0)} color={getStatusColor('FAILED')} />
        <CountChip label={getStatusLabel('GENERATING')} count={Number(counts?.GENERATING || 0) + Number(counts?.REGENERATING || 0)} color={getStatusColor('GENERATING')} />
      </Stack>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {allApproved ? (
          <Tooltip title="Todas as imagens foram aprovadas. A produção está pronta para iniciar a montagem do vídeo.">
            <Chip
              color="success"
              variant="filled"
              icon={<CheckCircleIcon fontSize="small" />}
              label="Todas aprovadas — Pronto para montar"
            />
          </Tooltip>
        ) : (
          <Tooltip title={hasBlocking ? `Bloqueado por: ${BLOCKING_STATUSES.join(', ')}` : 'Aprovação pendente'}>
            <Chip
              color="warning"
              variant="filled"
              label="Pendente de aprovação"
            />
          </Tooltip>
        )}
        <Button
          size="small"
          variant="contained"
          color="success"
          startIcon={<CheckCircleIcon fontSize="small" />}
          disabled={review?.loading || !total}
          onClick={() => review?.approveAll?.()}
        >Aprovar Todas</Button>
        <Button
          size="small"
          variant="outlined"
          color="warning"
          startIcon={<RefreshIcon fontSize="small" />}
          disabled={review?.loading || !rejectedFailed}
          onClick={() => review?.regenerateRejected?.()}
        >Regenerar Apenas Reprovadas ({String(rejectedFailed)})</Button>
      </Stack>
    </Box>
  );
}
